export default "/_next/static/images/a18384418c14c9e1df0bb530ee15f84b.svg";